import pt from "./locales/pt";
import es from "./locales/es";
import en from "./locales/en";

const DICTS = { pt, es, en };
const VALID = ["pt", "es", "en"];

export function getLang() {
  const l = window.__auroraLang || localStorage.getItem("aurora_lang") || "pt";
  return VALID.includes(l) ? l : "pt";
}

export function setLang(l) {
  if (!VALID.includes(l)) return;
  localStorage.setItem("aurora_lang", l);
  window.__auroraLang = l;
  window.location.reload();
}

export function t(key, vars) {
  const lang = getLang();
  let s = (DICTS[lang] && DICTS[lang][key]) || DICTS.pt[key] || key;
  if (vars) Object.keys(vars).forEach(k => { s = s.split("{" + k + "}").join(vars[k]); });
  return s;
}
